import { Routes, Route, useLocation } from 'react-router-dom';
import { useEffect, useRef } from 'react';
import Chat from '~/pages/Chat';
import Roulette from '~/pages/Roulette';
import HomePage from '~/pages/HomePage';
import AdminPanel from '~/pages/AdminPanel';
import ModeratorPanel from '~/pages/ModeratorPanel';
import Profile from '~/pages/Profile';
import PrivateChats from '~/pages/PrivateChats';
import ServerInfo from '~/pages/ServerInfo';
import Users from '~/pages/Users';
import Contact from './pages/Contant';
import AboutUs from './pages/AboutUs';
import Help from './pages/Help';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsAndConditions from './pages/TermsAndConditions ';
import PageNotFound from './pages/PageNotFound';
import Activate from './pages/Activate';
import ResetPassword from './pages/ResetPassword';
import { useAuth } from '~/hooks/useAuth';
import { authStorage } from '~/services/authStorage';
import { useGlobalContext } from '~/context/GlobalContext';
import Websocket from '~/components/Websocket';
import '~/styles/App.css';

function App() {
  const { initAuth, joinRoom, logout } = useAuth();
  const { context } = useGlobalContext();
  const location = useLocation();
  const rejoinGuardRef = useRef(false);

  // Jednorazowo przy starcie: przywróć sesję z tokena.
  // W trybie "nie zapamiętuj" tokeny żyją tylko w pamięci, więc po odświeżeniu nie ma czego
  // przywracać — initAuth zwróci null i użytkownik zostaje wylogowany na stronie głównej.
  useEffect(() => {
    initAuth();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // "Zapamiętaj mnie": użytkownik ZAWSZE ląduje na /chat. Łapie wszystkie przypadki, w których
  // trafia na "/" — wejście na stronę główną, odświeżenie /chat (Chat.tsx bije wtedy redirectem
  // na "/", bo router state ginie) oraz powrót z innej podstrony.
  useEffect(() => {
    if (!context.authUser || !authStorage.isRememberMeEnabled()) return;
    if (location.pathname !== '/') return;
    if (rejoinGuardRef.current) return;
    rejoinGuardRef.current = true;
    joinRoom(context.authUser).finally(() => { rejoinGuardRef.current = false; });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname, context.authUser]);

  // "Nie wylogowywuj mnie" ODZNACZONE: sesja jest ulotna. Gdy zalogowany użytkownik, który był już
  // w czacie (sessionStorage 'user'), wraca na stronę główną — kończymy sesję i ląduje wylogowany.
  // Odświeżenie obsługuje się samo: tokeny pamięciowe giną, więc authUser jest wtedy null.
  // Świeże logowanie nie jest dotknięte — sessionStorage 'user' pojawia się dopiero po wejściu do czatu.
  useEffect(() => {
    if (!context.authUser || authStorage.isRememberMeEnabled()) return;
    if (location.pathname !== '/') return;
    if (!window.sessionStorage.getItem('user')) return;
    logout();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname, context.authUser]);

  return (
    <>
    {/* Websocket żyje na poziomie App, by jedna sesja przetrwała nawigację /chat <-> /roulette */}
    <Websocket />
    <Routes>
      <Route path="/" element={ <HomePage/> }/>
      <Route path="/chat" element={ <Chat/> }/>
      <Route path="/roulette" element={ <Roulette/> }/>
      <Route path="/o-nas" element={ <AboutUs/> }/>
      <Route path="/kontakt" element={ <Contact/> }/>
      <Route path="/pomoc" element={ <Help/> }/>
      <Route path="/polityka-prywatnosci" element={< PrivacyPolicy/> }/>
      <Route path="/regulamin" element={ <TermsAndConditions/> }/>
      <Route path="/aktywacja/:token" element={ <Activate/> }/>
      <Route path="/reset-hasla/:token" element={ <ResetPassword/> }/>
      <Route path="/admin" element={ <AdminPanel/> }/>
      <Route path="/moderator" element={ <ModeratorPanel/> }/>
      <Route path="/profile" element={ <Profile/> }/>
      <Route path="/private-chats" element={ <PrivateChats/> }/>
      <Route path="/server" element={ <ServerInfo/> }/>
      <Route path="/users" element={ <Users/> }/>
      <Route path="*" element={ <PageNotFound/> }/>
    </Routes>
    </>
  );
};

export default App;
